import { Categories } from './lobby-details-model/categories.model';
import { GameMetaDataMap } from './lobby-details-model/game-metadata.model';
import { LobbyItemBaseModel } from './lobby-details-model/lobby-item.model';

export class LobbyItem extends LobbyItemBaseModel {
    categoriesMap: Map<string, Categories>;
    categoryNameLangMap: Map<string, string>;
    stickerNameMap: Map<string, string>;
    gameMetaDataMap: Map<string, GameMetaDataMap>;
    setCategoriesMap(map: Map<string, Categories>) {
        this.categoriesMap = map;
        this.lsCategoriesMap = Array.from(map.entries());
    }

    setcategoryNameLangMap(map: Map<string, string>) {
        this.categoryNameLangMap = map;
        this.lsCategorytNameLangMap = Array.from(map.entries());
    }

    setStickerNameMap(map: Map<string, string>) {
        this.stickerNameMap = map;
        this.lsStickerNameMap = Array.from(map.entries());
    }

    setGameMetaDataMap(map: Map<string, GameMetaDataMap>) {
        this.gameMetaDataMap = map;
        this.lsGameMetaDataMap = Array.from(map.entries());
    }

    setLobbyItemFromLocalStorage(lobbyInfoLocalStorage: LobbyItemBaseModel) {
        if (lobbyInfoLocalStorage) {
            if (lobbyInfoLocalStorage.lsCategoriesMap && lobbyInfoLocalStorage.lsCategoriesMap.length > 0) {
                this.categoriesMap = new Map(lobbyInfoLocalStorage.lsCategoriesMap);
            }
            if (lobbyInfoLocalStorage.lsCategorytNameLangMap && lobbyInfoLocalStorage.lsCategorytNameLangMap.length > 0) {
                this.categoryNameLangMap = new Map(lobbyInfoLocalStorage.lsCategorytNameLangMap);
            }
            if (lobbyInfoLocalStorage.lsStickerNameMap && lobbyInfoLocalStorage.lsStickerNameMap.length > 0) {
                this.stickerNameMap = new Map(lobbyInfoLocalStorage.lsStickerNameMap);
            }
            if (lobbyInfoLocalStorage.lsGameMetaDataMap && lobbyInfoLocalStorage.lsGameMetaDataMap.length > 0) {
                this.gameMetaDataMap = new Map(lobbyInfoLocalStorage.lsGameMetaDataMap);
            }
            if (lobbyInfoLocalStorage.lbyTempName) {
                this.lbyTempName = lobbyInfoLocalStorage.lbyTempName;
            }
            if (lobbyInfoLocalStorage.lbyTargetType) {
                this.lbyTargetType = lobbyInfoLocalStorage.lbyTargetType;
            }
            if (lobbyInfoLocalStorage.optSegName) {
                this.optSegName = lobbyInfoLocalStorage.optSegName;
            }
            if (lobbyInfoLocalStorage.lsCatVsFeatureMetadata) {
                this.catVsFeatureMetadata = new Map(lobbyInfoLocalStorage.lsCatVsFeatureMetadata);
            }

            this.lobbyGameIconImageSuffix = lobbyInfoLocalStorage.lobbyGameIconImageSuffix;
        }
    }
}

export interface LobbyInfo {
    key: string;
    value: LobbyItem;
}
